<template>
  <div class="profile-page">
    <!-- 头部用户信息区 -->
    <div class="profile-header">
      <!-- 左侧头像 -->
      <div class="avatar-section">
        <div v-if="userInfo.avatar" class="user-avatar">
          <img :src="userInfo.avatar" alt="avatar" />
        </div>
        <div v-else class="user-avatar avatar-placeholder" :style="{ background: userInfo.avatarBg }"></div>
      </div>

      <!-- 右侧信息区 -->
      <div class="user-info">
        <!-- 用户名 -->
        <h2 class="user-name">{{ userInfo.nickname }}</h2>

        <!-- 昵称IP直播间 -->
        <div class="user-meta-row">
          <span class="meta-label">昵称</span>
          <span class="meta-value">{{ userInfo.name }}</span>
          <span class="meta-dot">·</span>
          <span class="meta-label">IP</span>
          <span class="meta-value">{{ userInfo.ip }}</span>
          <!-- <span class="meta-dot">·</span> -->
          <!-- <span class="meta-label">直播间</span> -->
          <!-- <span class="meta-value">{{ userInfo.roomId }}</span> -->
        </div>

        <!-- 数据统计 -->
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.following }}</span>
            <span class="stat-label">关注</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.followers }}</span>
            <span class="stat-label">粉丝</span>
          </div>
          <div class="stat-item">
            <span class="stat-num">{{ userInfo.likes }}</span>
            <span class="stat-label">赞</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div v-if="pinglun === null"></div>
        <div v-else class="action-btns">
          <button class="follow-btn" :class="{ followed: isFollowed }" @click="toggleFollow">
            {{ isFollowed ? '已关注' : '关注' }}
          </button>
        </div>
        

        <!-- 个人简介 -->
        <div class="user-bio">
          <p class="bio-line">
            <span>{{ userInfo.bio }}</span>
            <span class="bio-icon">🌻</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 导航标签页 -->
    <div class="profile-tabs">
      <div class="tabs-left"></div>
      <div class="tabs-right">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          :class="{ active: activeTab === index }"
          @click="switchTab(index)"
        >
          {{ tab.name }}
          <i v-if="tab.icon" :class="tab.icon"></i>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="profile-content">
      <!-- 作品 -->
      <div v-if="activeTab === 0" class="works-section">
        <div v-if="worksList.length > 0" class="works-grid">
          <div v-for="(item, index) in worksList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ backgroundImage: 'url(' + worksList[index].hfimage + ')' }">
              <span class="live-badge">回放</span>
            </div>
            <div class="work-info">
              <img :src="userInfo.avatar || item.image " class="work-avatar" alt="avatar" />
              <span class="work-name">{{ userInfo.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>暂无作品</p>
        </div>
      </div>

      <!-- 收藏 -->
      <div v-else-if="activeTab === 1" class="favorite-section">
        <div v-if="favoriteList.length > 0" class="works-grid">
          <div v-for="(item, index) in favoriteList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ background: item.cover }">
              <span v-if="item.isLive" class="live-badge">直播</span>
              <span v-if="item.viewers" class="viewer-badge">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="work-info">
              <img :src="item.avatar" class="work-avatar" alt="avatar" />
              <span class="work-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>暂无收藏</p>
        </div>
      </div>

      <!-- 赞过 -->
      <div v-else-if="activeTab === 2" class="liked-section">
        <div v-if="likedList.length > 0" class="works-grid">
          <div v-for="(item, index) in likedList" :key="index" class="work-card" @click="playWork(item)">
            <div class="work-cover" :style="{ background: item.cover }">
              <span v-if="item.isLive" class="live-badge">直播</span>
              <span v-if="item.viewers" class="viewer-badge">
                <i class="el-icon-user"></i>{{ item.viewers }}
              </span>
            </div>
            <div class="work-info">
              <img :src="item.avatar" class="work-avatar" alt="avatar" />
              <span class="work-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>暂无赞过的内容</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ProfileTr',
  data() {
    return {
      // 用户信息 - 从接口获取
      userInfo: {
        nickname: '',
        name: '',
        avatar: '',
        avatarBg: 'linear-gradient(135deg, #FF6B9D 0%, #C084FC 100%)',
        ip: '',
        roomId: '',
        following: 0,
        followers: '',
        likes: '',
        bio: '',
        liveTime: ''
      },
      // 关注状态
      isFollowed: false,
      // 标签页
      tabs: [
        { name: '直播回放', id: 'works' },
        { name: '收藏', id: 'favorite', icon: 'el-icon-lock' },
        { name: '赞过', id: 'liked' }
      ],
      // 当前选中标签
      activeTab: 0,
      // 作品列表
      worksList: [],
      // 收藏列表
      favoriteList: [],
      // 赞过列表
      likedList: [],
      // 主播ID
      zhuboId: '',
      // 评论判断
      pinglun: 1
    }
  },
  created() {
    // 从路由参数或其他方式获取姓名
    const name = this.$route.query.name || this.$route.params.name
    // 页面加载时请求主播信息接口
    this.fetchAnchorInfo(name)
  },
  methods: {
    // 请求主播信息接口
    fetchAnchorInfo(name) {
      // 使用axios发送请求
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/zbxx', {
        params: { name }
      }).then(res => {
        // 判断接口返回成功
        if (res.data.code === 1 && res.data.data) {
          const data = res.data.data;
          this.pinglun = data.zhuboid;
          // 保存主播ID
          this.zhuboId = data.anchorid || data.id || ''
          // 映射接口数据到页面字段
          this.userInfo = {
            nickname: data.anchor_name || data.yhname || '', // 主播昵称
            name: data.anchor_name || data.yhname || '', // 昵称
            avatar: data.touxiang || data.image || '', // 头像
            image: data.image || '', // 作品封面图
            avatarBg: 'linear-gradient(135deg, #FF6B9D 0%, #C084FC 100%)',
            ip: data.diqu || '', // IP/地区
            roomId: data.anchor_number ||  '未实名' ||  '', // 直播间号
            following: 0, // 关注数（接口无对应字段）
            followers: data.fensi || '', // 粉丝数
            likes: data.hot || '', // 热度/赞数
            bio: data.content || '', // 个人简介
            liveTime: data.add_time || '' // 直播时间
          }
          // 检查关注状态
          this.checkFollowStatus()
          // 设置作品列表（只有一个作品）
          const zuizhong = data.id>11 || data.anchorid>11 || data.pinglun==0 || data.zhuboid === null
          console.log(zuizhong)
          if(data.id>11 || data.anchorid>11 || data.pinglun==0 || data.zhuboid === null){
            // this.worksList = []
            return;
          } 
          this.setWorksList(data)
        }
      })
    },
    // 检查关注状态
    checkFollowStatus() {
      const loginInfo = this.$store.state.LoginStorage
      if (loginInfo && loginInfo.zbid && this.zhuboId) {
        // 判断zbid数组中是否包含当前主播ID
        this.isFollowed = loginInfo.zbid.includes(parseInt(this.zhuboId)) || loginInfo.zbid.includes(this.zhuboId)
      }
    },
    // 检查是否登录
    checkLogin() {
      const loginInfo = this.$store.state.LoginStorage
      return loginInfo && loginInfo.id
    },
    // 获取登录用户信息
    getUserInfo() {
      return this.$store.state.LoginStorage
    },
    // 切换关注/取消关注
    toggleFollow() {
      // 检查是否登录
      if (!this.checkLogin()) {
        this.$message.warning('请先登录后再关注')
        this.$router.push('/login')
        return
      }

      const userInfo = this.getUserInfo()
      if (!userInfo || !userInfo.id) {
        this.$message.warning('用户信息获取失败')
        return
      }

      // 请求关注接口
      // 粉丝数转为数字处理
      const currentFans = parseInt(this.userInfo.followers) || 0
      // 传给接口的是当前粉丝数（操作前的）
      const apiFans = currentFans
      // 页面上要显示的新粉丝数（操作后的）
      const displayFans = this.isFollowed ? currentFans - 1 : currentFans + 1
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/zbgz', {
        yhid: userInfo.id,
        zbid: this.zhuboId || '',
        zbfs: apiFans,
        add: this.isFollowed ? '' : 'add'
      }).then(res => {
        console.log('关注接口返回:', res.data)
        if (res.data.code === 1) {
          // 存储到本地浏览器
          localStorage.setItem('TTxq', JSON.stringify(res.data.data))
          // 存储到 Vuex
          this.$store.commit('LoginModification', res.data.data)
          // 更新关注状态和粉丝数
          this.userInfo.followers = String(displayFans)
          this.isFollowed = !this.isFollowed
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      })
    },
    // 发送消息
    sendMessage() {
      this.$emit('sendMessage')
    },
    // 显示更多
    showMore() {
      this.$emit('showMore')
    },
    // 切换标签
    switchTab(index) {
      this.activeTab = index
    },
    // 播放作品
    playWork(item) {
      console.log(item.anchorid, this.zhuboId);
      this.$router.push(`/hf/${this.zhuboId}/${item.anchorid}`)
    },
    // 设置作品列表
    setWorksList(data) {
      // 只有一个作品：封面用image字段，名称用anchor_name
      // console.log(data)
      this.worksList.push(...data.video_list);
    }
  }
}
</script>

<style scoped lang="scss">
// 页面主容器
.profile-page {
  min-height: 100vh;
  background: #fff;
  padding: 40px 48px;
}

// 头部用户信息区
.profile-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

// 头像区域
.avatar-section {
  flex-shrink: 0;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.user-avatar>img{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

// 用户信息区
.user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// 用户名
.user-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

// 元信息行
.user-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #999;
}

.meta-label {
  color: #999;
}

.meta-value {
  color: #666;
}

.meta-dot {
  color: #ccc;
}

// 数据统计
.user-stats {
  display: flex;
  gap: 24px;
  margin-top: 4px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.stat-num {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.stat-label {
  font-size: 13px;
  color: #666;
}

// 操作按钮
.action-btns {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}

.follow-btn {
  padding: 8px 24px;
  background: #8B5CF6;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }

  &.followed {
    background: #E5E7EB;
    color: #999;
  }
}

.message-btn,
.more-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 50%;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f5f5f5;
  }
}

// 个人简介
.user-bio {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}

.bio-line {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.bio-icon {
  font-size: 14px;
}

// 导航标签页
.profile-tabs {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  .tabs-left {
    width: 120px;
    flex-shrink: 0;
  }

  .tabs-right {
    display: flex;
    gap: 48px;
  }
}

.tab-item {
  font-size: 15px;
  color: #666;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 12px;
    color: #999;
  }

  &:hover {
    color: #8B5CF6;
  }

  &.active {
    color: #8B5CF6;
    font-weight: 500;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: #8B5CF6;
      border-radius: 1px;
    }
  }
}

// 内容区域
.profile-content {
  // 作品网格与头像垂直对齐
}

// 作品网格
.works-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding-left: 0;
}

.work-card {
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.work-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
}

.live-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 8px;
  background: #906bff;
  border-radius: 4px;
  font-size: 11px;
  color: #fff;
}

.viewer-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 6px;
  border-radius: 8px;
}

.work-info {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

.work-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.work-name {
  font-size: 15px;
  color: #333;
}

// 空状态
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}
</style>